<div class="button-wrapper">
  <button
    type="button"
    (click)="goBack.emit()"
    [disabled]="currentStep === firstStep"
  >
    Atrás
  </button>
</div>
